import OneSignal from 'react-onesignal';

import api from '../api';
import registerSW from '../registerServiceWorker';
import { isInApp } from '../hooks/useInstallPwa';
import { openPushPermissionTeaser } from '../actions/pwa';

const ONE_SIGNAL_APP_ID = process.env.ONE_SIGNAL_APP_ID;

let sdkInitStarted = false;
let sdkReady = false;

const syncSubscriptionToBackend = async (isSubscribed) => {
  await api.artisans.custom('push-subscription').patch({
    pushNotificationsEnabled: isSubscribed,
  });
};

const syncPwaInstalled = async (installed) => {
  await api.artisans.custom('pwa-installed').patch({
    pwaInstalled: installed,
  });
};

export const initOneSignal = async (artisanId) => {
  if (!ONE_SIGNAL_APP_ID) {
    return;
  }

  if (!sdkInitStarted) {
    sdkInitStarted = true;
    try {
      await OneSignal.init({
        appId: ONE_SIGNAL_APP_ID,
        notifyButton: { enable: false },
        allowLocalhostAsSecureOrigin: process.env.NODE_ENV === 'development',
        serviceWorkerParam: { scope: '/oneSignal/' },
        serviceWorkerPath: 'oneSignal/OneSignalSDKWorker.js',
        welcomeNotification: { disable: true },
        promptOptions: {
          slidedown: {
            prompts: [
              {
                type: 'push',
                autoPrompt: false,
              },
            ],
          },
        },
      });

      sdkReady = true;

      registerSW();

      if (isInApp) {
        syncPwaInstalled(true);
      }

      window.addEventListener('appinstalled', () => {
        syncPwaInstalled(true);
      });

      OneSignal.User.PushSubscription.addEventListener('change', (event) => {
        syncSubscriptionToBackend(event.current.optedIn);
      });
    } catch {
      sdkInitStarted = false;
      return;
    }
  }

  if (!sdkReady) {
    return;
  }

  await OneSignal.login(artisanId.toString());
  OneSignal.User.addTag('role', 'artisan');

  if (isInApp && Notification.permission === 'default') {
    const onConfirm = () => OneSignal.Notifications.requestPermission();
    openPushPermissionTeaser(onConfirm);
  }
};

export const logoutOneSignal = async () => {
  if (!sdkReady) {
    return;
  }
  await OneSignal.logout();
};
